import { render, staticRenderFns } from "./ProfileDropdown.vue?vue&type=template&id=cd9ebb20"
import script from "./ProfileDropdown.vue?vue&type=script&lang=js"
export * from "./ProfileDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/devstark/spreadsimple/spreadsimple-app/main-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cd9ebb20')) {
      api.createRecord('cd9ebb20', component.options)
    } else {
      api.reload('cd9ebb20', component.options)
    }
    module.hot.accept("./ProfileDropdown.vue?vue&type=template&id=cd9ebb20", function () {
      api.rerender('cd9ebb20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/profile-dropdown/ProfileDropdown.vue"
export default component.exports